export default function ProductDeleteModalController(
  $scope,
  $uibModalInstance,
  product,
  $state,
  productService,
  gettextCatalog
) {
  'ngInject';
  $scope.product = product;

  $scope.ok = function() {
    $scope.errorFlag = false;
    $scope.deleting = true;
    productService.deleteProduct($scope.product.id).then(
      function(response) {
        $scope.$emit('productsUpdated');
        $uibModalInstance.close();
        $state.go('admin.products');
      },
      function(error) {
        var errorMsg = gettextCatalog.getString('An error occurred while deleting the template.');
        if (error.data || error.status) {
          if (error.data.message) {
            errorMsg = error.data.message + ' ' + (error.status.toString() + ' - ' + error.statusText.toString());
          } else {
            errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
          }
        } else {
          errorMsg += gettextCatalog.getString('. Please try again later.');
        }
        $scope.errorFlag = true;
        $scope.errorText = errorMsg;
        $scope.deleting = false;
      }
    );
  };

  $scope.cancel = function() {
    $uibModalInstance.close('cancel');
  };

  $scope.$on('$locationChangeStart', function(event, next, current) {
    $scope.cancel();
  });
}
